// Fusionne les fragments d'un namespace ({fr,en,es} chacun) en un dictionnaire unique.
// Chaque lot de retrofit possède SON fichier fragment : aucun conflit d'édition entre
// lots parallèles. Une clé dupliquée entre fragments est un bug d'intégration — on
// jette en dev pour la voir immédiatement, on écrase silencieusement en prod.
export const LANGS = ["fr", "en", "es"];

export function mergeFragments(fragments) {
  const out = { fr: {}, en: {}, es: {} };
  for (const frag of fragments) {
    for (const lang of LANGS) {
      const dict = frag[lang] || {};
      for (const key of Object.keys(dict)) {
        if (process.env.NODE_ENV !== "production" && key in out[lang]) {
          throw new Error(`i18n: duplicate key "${key}" (${lang}) across fragments`);
        }
        out[lang][key] = dict[key];
      }
    }
  }
  return out;
}
